<script lang="ts">
  import {
    Flex,
    Input,
    Icon,
    LocationChooser,
    LocationPinSolid,
    Radio,
    Text,
  } from "@getprovi/craft";

  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import PunchoutSessionStore from "@retailer/svelte/stores/PunchoutSessionStore";

  import retailerContext from "@modern/services/retailer_context";

  import type { RetailerType } from "@shared/types/Retailer";

  let currentRetailer: RetailerType = { ...$CurrentRetailerStore };
  let retailers: RetailerType[] = window["PRELOADED_RETAILERS"] || [];
  let selectedRetailer: RetailerType = { ...currentRetailer };

  const reset = (): void => {
    selectedRetailer = { ...currentRetailer };
  };

  const handleChange = (retailer: RetailerType): void => {
    selectedRetailer = retailer;
  };

  const setRetailer = (retailer: RetailerType): void => {
    retailerContext.setRetailer(selectedRetailer.id);
  };

  let searchLocations: string = "";
  $: filteredLocations = [...retailers].filter(r => {
    const downcased = searchLocations.toLowerCase();
    return downcased.split(" ").every(w => {
      return [r.name, r.address1, r.address2, r.address3, r.city, r.state, r.zip]
        .join(" ")
        .toLowerCase()
        .includes(w);
    });
  }) as RetailerType[];
</script>

{#if $PunchoutSessionStore?.is_active_punchout}
  <Flex gap="8" center itemsCenter class="py-12 px-24 self-stretch tablet:self-start">
    <span class="p-2">
      <Icon iconName={LocationPinSolid} color="brand" size="icon-base" />
    </span>
    <Text color="brand" semibold data-testid="location-chooser-single-retailer"
      >{currentRetailer.name}</Text
    >
  </Flex>
{:else}
  <LocationChooser
    disabled={selectedRetailer.id === currentRetailer.id}
    label={currentRetailer.name}
    handleOpen={reset}
    submit={setRetailer}
  >
    {#if retailers.length > 5}
      <Input
        search
        id="search-locations"
        label="Search"
        hiddenLabel
        placeholder="Search locations"
        bind:value={searchLocations}
      />
    {/if}

    {#each filteredLocations as retailer}
      {@const { id, name, address1, city, state, zip } = retailer}
      <Radio
        bind:group={selectedRetailer.id}
        testId={`retailer-${retailer.id}`}
        id={`retailer-${retailer.id}`}
        name={`retailer-${retailer.id}`}
        checked={selectedRetailer.id === id}
        value={id}
        label={name}
        on:click={() => handleChange(retailer)}
      >
        <Flex as="span" column gap="0">
          <span>{address1}</span>
          <span>{city}, {state} {zip}</span>
        </Flex>
      </Radio>
    {/each}
  </LocationChooser>
{/if}
